import Activated from './Activated.component';

export default Activated;
